import { Divider } from "@mui/material";

export function NCRBHorizontalDivider() {
    return (
        <Divider sx={{ opacity: 0.2, border: '1px dashed var(--components-divider, #919EAB)', borderOpacity: 0.2, strokeOpacity: 0.2, strokeDasharray: [2, 3] }} />
    );
}
